import {
	Dialog,
	DialogBackdrop,
	Transition,
	TransitionChild,
} from "@headlessui/react";
import { CheckIcon, XCircleIcon } from "@heroicons/react/24/solid";
import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import services from "utils/services";
import dayjs from "dayjs";
import { useAuth } from "provider/useAuth";

export interface ModalProps {
	show: boolean;
	isAdmin?: boolean;
	employee: any;
	showForm?: boolean;
	onCloseModal: () => void;
}

const ModalCongesRecup: FC<ModalProps> = ({
	show,
	employee,
	onCloseModal,
	showForm = false,
}) => {
	const authContext = useAuth();
	const isEdit = useRef(authContext.user.role === "ADMIN");
	const [list, setList] = useState<any[]>([]);
	const [type, setType] = useState("");
	const [dateFrom, setDateFrom] = useState<any>("");
	const [dateTo, setDateTo] = useState<any>("");
	const [qty, setQty] = useState<any>(0);
	const [comment, setComment] = useState("");
	const [soldeConges, setSoldeConges] = useState(employee.soldeConges);
	const [soldeRecup, setSoldeRecup] = useState(employee.soldeRecup);
	const today = dayjs();
	useEffect(() => {
		loadCongesRecup();
	}, [employee]);

	// const getEmployee = () => {
	// 	services.getOneUser(
	// 		employee._id,
	// 		(success) => {
	// 			setSoldeConges(success.user.soldeConges);
	// 			setSoldeRecup(success.user.soldeRecup);
	// 		},
	// 		(error) => {}
	// 	);
	// };

	const loadCongesRecup = () => {
		services.getCongesRecup(
			{ employee: employee._id },
			(res) => {
				setList(res.vacations);
				if (res.vacations.length) {
					setSoldeConges(res.vacations[0].employee.soldeConges);
					setSoldeRecup(res.vacations[0].employee.soldeRecup);
				}
			},
			(error) => {}
		);
	};

	const deleteLine = (id: string) => {
		services.deleteOneCongesRecup(
			{ id },
			(res) => {
				loadCongesRecup();
			},
			(error) => {}
		);
	};

	const onSave = () => {
		services.saveCongesRecup(
			{ type, dateFrom, dateTo, qty, employee, comment },
			(res) => {
				loadCongesRecup();
				setType("");
				setQty(0);
				setDateFrom("");
				setDateTo("");
				setComment("");
				// getEmployee();
			},
			(error) => {}
		);
	};
	return (
		<Transition appear show={show} as={Fragment}>
			<Dialog
				as="div"
				className="fixed inset-0 z-50"
				onClose={() => {
					onCloseModal();
				}}
			>
				<div className="flex items-stretch md:items-center justify-center h-full text-center md:px-4">
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<DialogBackdrop className="fixed inset-0 bg-black/40 dark:bg-black/70" />
					</TransitionChild>

					{/* This element is to trick the browser into centering the modal contents. */}
					<span className="inline-block align-middle" aria-hidden="true">
						&#8203;
					</span>
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<div className="relative inline-flex xl:py-8 w-full max-h-full min-w-[50%] max-w-[600px]">
							<div
								className="flex-1 flex overflow-hidden max-h-full p-8 w-full text-left align-middle transition-all transform lg:rounded-2xl bg-white 
				  dark:bg-neutral-900 dark:border dark:border-slate-700 dark:text-slate-100 shadow-xl max-h-[500px]"
							>
								<span className="absolute right-3 top-3 z-50">
									<ButtonClose onClick={onCloseModal} />
								</span>

								<div className="flex-1 overflow-y-auto rounded-xl hiddenScrollbar">
									{showForm && (
										<div className="flex flex-row justify-between items-end">
											<h3 className="text-xl font-semibold mt-2">
												<span className="text-sm">
													{employee.firstName} {employee.lastName.charAt(0)}.
												</span>
												<br />
												Conges / Récup.{" "}
												{/* {!isEdit && (
											<ButtonCircle
												className="transform ml-2 bg-slate-400 text-black hover:bg-slate-300"
												size="w-6 h-6"
												type="button"
												onClick={() => {
													setIsEdit(true);
													addOperation();
												}}
											>
												<PlusIcon className="h-4 w-4" />
											</ButtonCircle>
										)} */}
											</h3>
											<div className="mt-3 pr-5">
												<p className="font-semibold text-slate-900 text-sm">
													Solde initial au{" "}
													{dayjs(employee.dateSoldeInit).format("DD/MM/YYYY")}
												</p>
												<p className="text-slate-900 text-sm">
													Conges : {employee.soldeCongesInit} - Récup. :{" "}
													{employee.soldeRecupInit}{" "}
												</p>
											</div>
											{/* <div>
											<p>Congés : </p>
										</div> */}
										</div>
									)}
									{isEdit.current ? (
										<>
											<div>
												<div className="flex flex-row items-center mt-2.5 mb-1 border-bottom-1 gap-3">
													<div className="w-[95%]">
														<div className="flex flex-row items-center gap-3">
															<div className="">
																<input
																	placeholder="Date début"
																	className={"rounded text-sm"}
																	type="date"
																	value={dateFrom}
																	onChange={({ target }) =>
																		setDateFrom(target.value)
																	}
																/>
															</div>
															<div className="">
																<input
																	placeholder="Date fin"
																	className={"rounded text-sm"}
																	type="date"
																	value={dateTo}
																	onChange={({ target }) =>
																		setDateTo(target.value)
																	}
																/>
															</div>
															<div className="">
																<select
																	className="rounded text-sm "
																	value={type}
																	onChange={({ target }) => {
																		setType(target.value);
																	}}
																>
																	<option value=""></option>
																	<option value="CONGES">
																		Conges à deduire
																	</option>
																	<option value="RECUP">
																		Récup. à ajouter
																	</option>
																	<option value="RECUP_MOINS">
																		Récup. à déduire
																	</option>
																</select>
															</div>
															<div className="flex flex-col w-[80px]">
																<input
																	min={type === "CONGES" ? 0 : 0}
																	max={type === "CONGES" ? 18 : 2}
																	placeholder="Quantité"
																	type="number"
																	step="0.5"
																	className="rounded text-sm text-right"
																	value={qty}
																	onChange={({ target }) => {
																		setQty(Math.abs(parseFloat(target.value)));
																	}}
																/>
															</div>
														</div>
														<div className=" flex flex-row mt-1 gap-2">
															<input
																className="rounded text-sm w-[90%]"
																placeholder="Commentaire"
																type="text"
																value={comment}
																onChange={({ target }) => {
																	setComment(target.value);
																}}
															/>
															<ButtonPrimary
																className="!shadow-none"
																onClick={() => onSave()}
																disabled={
																	!type || !dateFrom || !dateTo || qty == 0
																}
															>
																<CheckIcon className="h-6 w-6" />
															</ButtonPrimary>
														</div>
													</div>
													{/* {index === operations.length - 1 && (
															<>
																<ButtonCircle
																	className="transform ml-2 bg-slate-400 text-black hover:bg-slate-300"
																	size="w-6 h-6"
																	type="button"
																	onClick={() => {
																		addOperation();
																	}}
																>
																	<PlusIcon className="h-4 w-4" />
																</ButtonCircle>
																<ButtonCircle
																	className="transform ml-2 bg-slate-400 text-black hover:bg-slate-300"
																	size="w-6 h-6"
																	type="button"
																	onClick={() => {
																		operations.splice(index, 1);
																		setOperations([...operations]);
																	}}
																>
																	<MinusIcon className="h-4 w-4" />
																</ButtonCircle>
															</>
														)} */}
												</div>
											</div>

											{/* <div className="flex flex-row items-center justify-between mb-1 border-bottom-1 p-2 gap-3">
												<div>
													<Label>&nbsp;</Label>
													<div className="flex flex-row items-center justify-between">
														<ButtonCircle
															className="transform ml-2 bg-slate-400 text-black hover:bg-slate-300"
															size="w-6 h-6"
															type="button"
															onClick={() => {
																save();
															}}
														>
															<CheckIcon className="h-4 w-6" />
														</ButtonCircle>
														<ButtonCircle
															className="transform ml-2 bg-danger text-black hover:bg-danger"
															size="w-6 h-6"
															type="button"
															onClick={() => {
																setOperations([]);
																setIsEdit(false);
															}}
														>
															<XMarkIcon className="h-4 w-6" />
														</ButtonCircle>
													</div>
												</div>
											</div> */}
										</>
									) : null}

									<div className="flex flex-row items-center mt-1.5 mb-4 border-b border-neutral-400 gap-5 justify-between">
										<div className="flex-1">
											<p className="font-semibold text-slate-900 text-lg">
												Solde au {today.format("DD/MM/YYYY")} :{" "}
												<span className="text-slate-900 text-lg font-normal">
													Conges : {soldeConges} / Récup. : {soldeRecup}{" "}
												</span>
											</p>
										</div>
									</div>
									{list.map((line: any, ind) => {
										return (
											<div
												className="flex flex-row items-center justify-between border-b border-neutral-400 "
												key={ind}
											>
												<div
													className={
														"flex flex-row item-center justify-between mt-2.5 mb-1 " +
														(dayjs(line.dateFrom).isAfter(today)
															? " bg-warning bg-opacity-20"
															: "")
													}
												>
													<p className="font-semibold text-slate-900 text-sm">
														<span className="text-muted text-[11px]">
															{dayjs(line.dateFrom).format("DD/MM/YYYY")}

															{line.dateTo
																? " - " +
																  dayjs(line.dateTo).format("DD/MM/YYYY")
																: ""}
														</span>
														<br />
														<span
															className={
																line.numberOfDays < 0
																	? "text-danger"
																	: line.type == "RECUP"
																	? "text-success"
																	: ""
															}
														>
															{line.type} : {line.numberOfDays} jour(s)
														</span>
														<br />
														{!!line.comment && (
															<span className="text-muted font-normal text-[13px]">
																{" "}
																{line.comment}
															</span>
														)}{" "}
													</p>
												</div>
												{isEdit.current &&
													dayjs(line.createdAt).isSame(dayjs(), "date") && (
														<div>
															<XCircleIcon
																className="w-5 h-5 cursor-pointer hover:w-6 hover:h-6"
																onClick={() => deleteLine(line._id)}
															/>
														</div>
													)}

												{/* {ind === list.length - 1 && (
													
												)} */}
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</Dialog>
		</Transition>
	);
};

export default ModalCongesRecup;
